import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewlinePipe } from './newline.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    NewlinePipe
  ],
  exports: [
    NewlinePipe
  ]
})
export class PipesModule { }
